/* -----------------------------------------------------------------------------

  AnyPicker - Customizable Picker for Mobile OS
  Version 2.0.9
  Copyright (c)2017 Lajpat Shah
  Contributors : https://github.com/nehakadam/AnyPicker/contributors
  Repository : https://github.com/nehakadam/AnyPicker
  Homepage : https://nehakadam.github.io/AnyPicker

 ----------------------------------------------------------------------------- */

/*

	language: Português
	file: AnyPicker-i18n-pr

*/

(function ($) {
    $.AnyPicker.i18n["pt"] = $.extend($.AnyPicker.i18n["pt"], {

    	// Common

    	headerTitle: "Selecionar",
		setButton: "Confirmar",
		clearButton: "Reiniciar",
		nowButton: "Agora",
		cancelButton: "Cancelar",
		dateSwitch: "Data",
		timeSwitch: "Horário",

    	// DateTime

        veryShortDays: "Do_Se_Te_Qa_Qu_Se_Sa".split("_"),
		shortDays: "Dom_Seg_Ter_Qua_Qui_Sex_Sab".split("_"),
		fullDays: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
		shortMonths: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
		fullMonths: "Janeiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),
		numbers: "0_1_2_3_4_5_6_7_8_9".split("_"),
		meridiem:
		{
			a: ["a", "p"],
			aa: ["am", "pm"],
			A: ["A", "P"],
			AA: ["AM", "PM"]
		},
		componentLabels: {
			date: "Data",
			day: "Dia",
			month: "Mês",
			year: "Ano",
			hours: "Horas",
			minutes: "Minutos",
			seconds: "Segundos",
			meridiem: "Meridiano"
		}

    });

})(jQuery);
